import SearchHistory from './SearchHistory'

export default SearchHistory
